import React, {Component} from "react";
import {Layout, Form, Input, Button, message} from "antd";

import Header from "../../components/header";
import LeftStu from "../../components/leftStu";
import {reqCurrent,reqLogOut,reqPwdTeacher} from "../../api";

import './password.less'
import storageUtils from "../../utils/storageUtils";
import memoryUtils from "../../utils/memoryUtils";

const {Content} = Layout;

/**
 * 密码路由组件
 */
export class Password extends Component {

    state = {
      user:{}
    };

    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            user: result.data
        });
    };


    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('newPwd')) {
            callback('两次密码输入不一致!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    };

    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    handleSubmit = e => {
        e.preventDefault();
        // let user = this.state.user;
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let loginData = new FormData();
                loginData.append("oldPwd",values.oldPwd);
                loginData.append("newPwd",values.newPwd);
                const result = await reqPwdTeacher(loginData);
                if(result.code === '000000') {
                    message.success("修改成功,请重新登录");
                    storageUtils.removeUser();
                    memoryUtils.user = {};
                    await reqLogOut();
                    this.props.history.replace("/login");
                }else {
                    message.error(result.data.msg);
                }
            }
        });
    };

    componentDidMount = async () => {
        this.getCurrentUser();
        sessionStorage.clear();
        document.getElementsByClassName("ant-menu-item")[2].click();
    };

    render() {

        const { getFieldDecorator } = this.props.form;
        const {validateStatus,errorMsg} = this.state;

        return(
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftStu>LeftStu</LeftStu>
                    <Content>
                        <div className='pass_box'>
                            <div className='password'>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Item
                                        label="旧密码"
                                        validateStatus={validateStatus}
                                        help={errorMsg }>
                                        {getFieldDecorator('oldPwd')(<Input.Password visibilityToggle={false}  autoComplete={"off"} className='pass_input' placeholder={"请输入旧密码......"}/>)}
                                    </Form.Item>
                                    <Form.Item label="新密码">
                                        {getFieldDecorator('newPwd', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入新密码!',
                                                },
                                                {
                                                    validator: this.validateToNextPassword,
                                                },
                                                { min:6, max: 20, message: '密码长度在6-20位' }
                                            ],
                                        })(<Input.Password autoComplete={"off"}  visibilityToggle={false} className='pass_input' placeholder={"请输入新密码......"}/>)}
                                    </Form.Item>
                                    {/* <Form.Item label="确认新密码">
                                        {getFieldDecorator('confirm', {
                                            validate: [
                                                // 在onBlur时，触发两个对象中的规则
                                                {
                                                    trigger: "onChange",
                                                    rules: [
                                                        {
                                                            validator: this.compareToFirstPassword,
                                                        },
                                                        { min:6, max: 20, message: '密码长度在6-20位' }
                                                    ],
                                                },
                                            ],
                                        })(<Input.Password autoComplete={"off"} onBlur={this.handleConfirmBlur} visibilityToggle={false} className='pass_input' placeholder={"请确认新密码......"}/>)}
                                    </Form.Item> */}
                                    <Form.Item label="确认新密码">
                                        {getFieldDecorator('confirm', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请确认新密码!',
                                                },
                                                {
                                                    validator: this.compareToFirstPassword,
                                                },
                                                { min:6, max: 20, message: '密码长度在6-20位' }
                                            ],
                                        })(<Input.Password autoComplete={"off"} onBlur={this.handleConfirmBlur} visibilityToggle={false} className='pass_input' placeholder={"请确认新密码......"}/>)}
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className='save'>
                                            保存
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrappedPassword = Form.create()(Password);
export default WrappedPassword;